import { Navigate } from 'react-router-dom';
import { useAppKeycloak } from '../../keycloak/keycloakUtils';
import appConfig from '../../config/config';

export function ProtectedRoute({ component: Component, roles = [], ...rest }) {
 
  const { keycloak } = useAppKeycloak();

  if (appConfig.keycloak.enableKeycloak) { // se la security è abilitata

    if (!keycloak?.authenticated) {
      keycloak.login();
      return null; // Evita di renderizzare il componente fino al login
    }

    if (roles.length > 0 && !roles.some((role) => keycloak.hasRealmRole(role))) {
      return <Navigate to="/unauthorized" replace />;
    }
  }  

  const RenderComponent = Component;
  return <RenderComponent {...rest} />;
}